import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Checkbox,
  ICheckboxOptions,
  IcoClose,
} from '../../../component';
import { handleMap } from '../dataLayers/controllers/dataLayers.controller';
import '../dataLayers/dataLayers.scss';
import { IconMap } from '../../../component/icon/map';
import { NameIdPair } from '../types';
import useOutsideClick from '../../../hooks/useOusideClick';

interface IMapViewProps {
  data: NameIdPair[];
}

const MapView = ({ data }: IMapViewProps): JSX.Element => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);

  const { preference, profileRules } = useSelector(
    (state: any) => state.layoutState
  );

  const { dataLayers } = useSelector((state: any) => state.dataLayersState);

  const { elastic_city_id } = useSelector(
    (state: any) => state.mapSearch.selectedCity || {}
  );

  const nls = require(`./nls/${preference.language.id}.json`);
  const { hasAccessGeneralMarkets } = profileRules;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleCheckbox = (e: ICheckboxOptions, name: string, id: string) => {
    const checked = {
      selected: e,
      name,
      id,
    };
    dispatch(
      handleMap({
        checked,
        city: hasAccessGeneralMarkets ? elastic_city_id : 5270,
      })
    );
  };

  useOutsideClick(containerRef, setIsOpen);

  return (
    <div className="map-view-actions--full-container" ref={containerRef}>
      {isOpen && (
        <div className="map-view--full-container">
          <div className="map-view-title-container">
            <p data-cy="MapViewTitle" className="map-view-title">
              {nls.mapVisualizations}
            </p>
            <Button
              cy="MapViewCloseBtn"
              className="btn normal"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <IcoClose cy="IconCloseMapView" />
            </Button>
          </div>
          {data.map((el) => (
            <Checkbox
              key={el.id}
              cy={`MapView${el.id}`}
              action={(e) =>
                handleCheckbox(e as ICheckboxOptions, el.name, el.id)
              }
              checked={dataLayers[el.id].selected}
              name={el.id}
              label={el.name}
              type="checkbox"
            />
          ))}
        </div>
      )}
      <Button
        cy="MapView"
        className={`${isOpen ? 'active' : ''} btn ${
          isOpen ? 'primary' : 'secondary'
        } normal large `}
        onClick={() => setIsOpen(!isOpen)}
      >
        <IconMap cy="MapIcon" fill={isOpen ? '#FFFFFF' : '#793EAD'} />
      </Button>
    </div>
  );
};

export default MapView;
